import { Box, Grid } from "@mui/material";
import WorkflowAssets from "./components/WorkflowAssets";
import WorkflowHeader from "./components/WorkflowHeader";
import WorkflowProgress from "./components/WorkflowProgress";
import WorkflowScopeTable from "./components/WorkflowScopeTable/WorkflowScopeTable";
import WorkflowScopeTableTitle from "./components/WorkflowScopeTable/WorkflowScopeTableTitle";
import useWorkflowDetail from "./hooks/useWorkflowDetail";

export default function WorkflowDetail() {
  const { loading, headerData, progressData, scopeData, workflowMrn } =
    useWorkflowDetail();

  return (
    <Grid container spacing={4.5}>
      <Grid size={12}>
        <WorkflowHeader headerData={headerData} />
      </Grid>
      <Grid size={12}>
        <WorkflowProgress progressData={progressData} />
      </Grid>
      <Grid container size={12} spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              alignSelf: "stretch",
              flex: "1 0 0",
              gap: 1,
            }}
          >
            <WorkflowScopeTableTitle scopeData={scopeData} />
            <WorkflowScopeTable loading={loading} scopeData={scopeData} />
          </Box>
        </Grid>
        {/* Activity table not active until we get activity data */}
        {/* <Grid size={{ xs: 12, md: 6 }}>
          <ActivityTable />
        </Grid> */}
      </Grid>
      <Grid size={12}>
        <WorkflowAssets workflowMrn={workflowMrn} />
      </Grid>
    </Grid>
  );
}
